<div class="menu" [class.hidden]="popupClass">
  <div class="menu-inner">
    <button class="hamburger-btn" (click)="toggleMobileNav()" aria-label="Toggle navigation">
      <span [inlineSVG]="'/icons/icon-hamburger.svg'"></span>
    </button>
    <div class="logo">
      <img src="/assets/logo/banen_logo.svg" />
    </div>
    <ul>
      <li routerLink="./" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        {{ 'global.my_profile' | translate }}
      </li>
      <ng-container *ngIf="cv$ | async as cv">
        <li *ngIf="cv.activated; else disabledVacanciesDesktop" routerLink="./vacancies" routerLinkActive="active">
          {{ 'global.my_vacanies' | translate }}
        </li>
        <ng-template #disabledVacanciesDesktop>
          <li (click)="onDisabledVacanciesClick()">
            {{ 'global.my_vacanies' | translate }}
          </li>
        </ng-template>
      </ng-container>
      <!-- <li routerLink="./professions" routerLinkActive="active">{{ 'nav.professions' | translate }}</li>
      <li routerLink="./companies" routerLinkActive="active">{{ 'nav.companies' | translate }}</li>
      <li routerLink="./educations" routerLinkActive="active">{{ 'nav.educations' | translate }}</li> -->
    </ul>
    <div class="menu-right">
      <lib-lang-droplist
        class="lang-switcher desktop-only"
        [noNative]="true"
        [dropdownIconsPath]="'/icons/icon-arrow-b-'"
        [triggerIcon]="'/icons/translate-icon.svg'"
      ></lib-lang-droplist>
      <bwc-profile-menu></bwc-profile-menu>
    </div>
  </div>
</div>

<!-- Mobile sidebar -->
<div class="mobile-sidebar-backdrop" *ngIf="mobileNavOpen" (click)="closeMobileNav()"></div>
<aside class="mobile-sidebar" [class.open]="mobileNavOpen">
  <div class="mobile-sidebar__header">
    <button class="mobile-sidebar__close" (click)="closeMobileNav()" aria-label="Close navigation">
      <img src="/assets/icons/icon-close.svg" alt="" />
    </button>
  </div>
  <nav class="mobile-sidebar__nav">
    <a routerLink="./" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobileNav()">
      {{ 'global.my_profile' | translate }}
    </a>
    <ng-container *ngIf="cv$ | async as cv">
      <a
        *ngIf="cv.activated; else disabledVacanciesMobile"
        routerLink="./vacancies"
        routerLinkActive="active"
        (click)="closeMobileNav()"
      >
        {{ 'global.my_vacanies' | translate }}
      </a>
      <ng-template #disabledVacanciesMobile>
        <a (click)="onDisabledVacanciesClick(); $event.preventDefault()">
          {{ 'global.my_vacanies' | translate }}
        </a>
      </ng-template>
    </ng-container>
  </nav>
  <lib-lang-droplist
    class="mobile-sidebar__lang"
    [noNative]="true"
    [dropdownIconsPath]="'/icons/icon-arrow-b-'"
    [triggerIcon]="'/icons/translate-icon.svg'"
  ></lib-lang-droplist>
</aside>

<div class="my-profile-container" [ngClass]="{ 'popup-opened': popupClass }">
  <div class="page-container">
    <router-outlet></router-outlet>
  </div>
</div>
<ng-container *ngIf="cv$ | async as cv">
  <div class="account-popup" *ngIf="showAccountPopup && !cv.activated">
    <button type="button" class="account-popup__close" (click)="closeAccountPopup()">&#10005;</button>
    <p class="account-popup__title">{{ 'global.save_profile_popup_title' | translate }}</p>
    <p class="account-popup__text">
      <button type="button" class="btn secondary breathing-button account-popup__btn" (click)="onCreateAccountClick()">
        {{ 'global.create_account' | translate }}
      </button>
    </p>
  </div>
</ng-container>
